import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import './App.css';

import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Properties from './pages/Properties';
import PropertyOptions from './pages/PropertyOptions';
import PropertyProviders from './pages/PropertyProviders';
import PropertyMessages from './pages/PropertyMessages';
import PropertySettings from './pages/PropertySettings';
import RevenuePage from './pages/RevenuePage';
import AdminOptions from './pages/AdminOptions';
import PublicProperty from './pages/PublicProperty';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import AdminRevenue from './pages/AdminRevenue';
import AdminConcierges from './pages/AdminConcierges';
import AdminAnalytics from './pages/AdminAnalytics';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import MentionsLegales from './pages/MentionsLegales';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/auth" />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/properties" element={<PrivateRoute><Properties /></PrivateRoute>} />
          <Route path="/properties/:id/options" element={<PrivateRoute><PropertyOptions /></PrivateRoute>} />
          <Route path="/properties/:id/providers" element={<PrivateRoute><PropertyProviders /></PrivateRoute>} />
          <Route path="/properties/:id/messages" element={<PrivateRoute><PropertyMessages /></PrivateRoute>} />
          <Route path="/properties/:id/settings" element={<PrivateRoute><PropertySettings /></PrivateRoute>} />
          <Route path="/revenue" element={<PrivateRoute><RevenuePage /></PrivateRoute>} />
          <Route path="/admin/options" element={<PrivateRoute><AdminOptions /></PrivateRoute>} />
          <Route path="/admin/revenue" element={<PrivateRoute><AdminRevenue /></PrivateRoute>} />
          <Route path="/admin/concierges" element={<PrivateRoute><AdminConcierges /></PrivateRoute>} />
          <Route path="/admin/analytics" element={<PrivateRoute><AdminAnalytics /></PrivateRoute>} />
          <Route path="/p/:link" element={<PublicProperty />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
